export const stripQueryParams = (params: string[]): void => {
  const url = new URL(window.location.href)
  params.forEach((param) => {
    url.searchParams.delete(param)
  })
  window.history.replaceState({}, document.title, url.toString())
}
